<template>
  <card-item card="item_process" 
    :tabs="tabs" 
    :activeTab="activeTab" 
    @setTab="setTab" :id="id" 
    :isFull="true"
    :infoKeys="infoKeys">
  </card-item>
</template>
<script>
export default {
  watch: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          key: 'task_results',
          title: "Результаты заданий",
          component: () => import("./Decisions"),
        },
      ],
      activeTab: 0,
      infoKeys: [
      ]
    };
  },
  methods: {
    setTab(val) {
      this.activeTab = val;
    }
  },
};
</script>